import React from "react";
import { Link } from "react-router-dom";
import "./Footer.css";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-wrapper">
        <div className="footer-container">
          <div className="footer-section">
            <h4>About JobKart</h4>
            <p>
              IndianJobs360 is a platform to view latest government jobs, results,
              and admit cards.
            </p>
          </div>

          <div className="footer-section">
            <h4>Pages</h4>
            <ul>
              <li><Link to="/">Home</Link></li>
              <li><Link to="/all-jobs">Latest Job</Link></li>
              <li><Link to="/all-admit-cards">Admit Card</Link></li>
              <li><Link to="/all-results">Result</Link></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4>Follow Us</h4>
            {/* <ul>
              <li><a href="#">Facebook</a></li>
              <li><a href="#">Twitter</a></li>
              <li><a href="#">YouTube</a></li>
            </ul> */}

            <ul>
                <li><a href="https://facebook.com" target="_blank" rel="noopener noreferrer">Facebook</a></li>
                <li><a href="https://twitter.com" target="_blank" rel="noopener noreferrer">Twitter</a></li>
                <li><a href="https://youtube.com" target="_blank" rel="noopener noreferrer">YouTube</a></li>
              </ul>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <p>&copy; {new Date().getFullYear()} IndianJobs360.com — All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
